import { render } from "./Listagem.vue?vue&type=template&id=636cc7c3"
import script from "./Listagem.vue?vue&type=script&lang=js"
export * from "./Listagem.vue?vue&type=script&lang=js"

import "./Listagem.vue?vue&type=style&index=0&id=636cc7c3&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__